module.exports = __webpack_public_path__ + "images/header-icon-mobile.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/header-icon-mobile.png
// module id = 345
// module chunks = 0